export const getFormErrorMessage = (error, validation = {}) => {
  if (!error) {
    return '';
  }

  if (!error.type) {
    return error.message || 'This field is invalid';
  }

  switch (error.type) {
    case 'required':
      return 'This field is required';
    case 'minLength':
      return `This field must be at least ${validation.minLength} characters long`;
    case 'maxLength':
      return `This field must be at most ${validation.maxLength} characters long`;
    default:
      return 'This field is invalid';
  }
};
